import mutateCreateSignedUploadURL from "./mutateCreateSignedUploadURL"

export default {
  mutateCreateSignedUploadURL
}



// WEBPACK FOOTER //
// ./src/S3/queries/index.js